import React, { Component } from 'react';
import { connect } from 'react-redux';
import { combineStates, currentPageState, productsDispatcher, productState, viewsState } from '../store';
import { GenericViewer, ProductCode, ProductDescription, ProductImage, ProductPrice, ProductStock } from '.';
import { PropTypes } from 'prop-types';
import { isEqual } from 'lodash';
import { Box } from '@mui/material';
import { translate } from '../services';

export class ProductItemDetailComponent extends Component {

  componentWillReceiveProps(nextProps){
    if(!isEqual(this.props.bomItems, nextProps.bomItems)){
      this.getMissingProducts(nextProps.bomItems);
    }
  }

  componentDidMount() {
    this.getMissingProducts(this.props.bomItems);
  }

  getMissingProducts = (bomItems) => {
    const { products } = this.props;
    if( bomItems?.length ) {
      this.props.getProducts(bomItems.filter(b => b.value?.name?!products[b.value.name]:!products[b.value])?.map(b => b.value?.name?b.value.name:b.value));
    }
  }

  getItems(){
    const { bomItems, amount, products } = this.props;
    if( bomItems?.length ){
      return bomItems.map((b) => {
        const itemName=b.value?.name?b.value.name:b.name;
        let item = {
	      name: itemName, 
        code: itemName, 
        amount: amount || 1,
        description: b.value?.value?b.value.value: b.value?.startsWith('V4AC')?products[b.name]?.properties?.filter(p=>p.name=='Translation.ZH')[0]?.value:products && products[b.name]?.description,
        shortDescriptionCN:products && products[b.name]?.shortDescriptionCN,
        materialNameLso:products && products[b.name]?.materialNameLso,
        configuredAcc:b.configuredAcc,
        looseacc:b.looseacc
	};

        if(products[itemName]){
          item.materialName = products[itemName].name || b,
          item.materialNameLso = products[itemName].code || b,
          item.materialGroup = products[itemName].materialGroupLso,
          item.productHierarchy = products[itemName].productHierarchyLso || products[itemName].productHierarchy,
          item.salesDocumentType = products[itemName].salesDocumentType,
          item.salesOrganization = products[itemName].salesOrganization,
          item.distributionChannel = products[itemName].distributionChannel,
          item.salesDivision = products[itemName].salesDivision
          item.imageDescription = products[itemName].imageDescription,
          item.imageLso = products[itemName].imageLso
          item.imageThumb = products[itemName].imageThumb
        }
        return item;
        });
    }
    return [];
  }

  render() {
    const { parentLayoutType, bomItems, isExpandable } = this.props;
    const detailTemplate = bomItems?.length ? ProductItemDetail : null;
    const items = this.getItems();

    let layout = parentLayoutType==="simple"?"productSimple":parentLayoutType;
    if(this.props.currentPage.currentPage==="productPage"){
      layout = this.props.views["product"]==="simple"?"productSimple":this.props.views["product"]
    }

    if(this.props.currentPage.currentPage==="detailedSearchPage" && parentLayoutType!=='detailed'){
      layout = "searchProductSimple"; 
    }
    if(this.props.currentPage.currentPage==="detailedSearchPage" && parentLayoutType==='detailed'){
      layout = "searchProductDetailed"; 
    }
    const accessories = Object.values( items );

    return !accessories || !accessories.length ? null : <>
    <Box width="100%" height="100%" sx={{display:{md:"flex", xs:"none", background: "var(--primary-color-background-secondary-white, #FAFAFA)", borderBottom:"1px solid var(--primary-color-grey-10, #EBEBEB)"}}}>
        <div className='accessory-list'>
        <GenericViewer 
          view= { 'cartaccessory' }
          parentLayoutType={layout}
          items={ accessories }
          detailTemplate={ detailTemplate }
          isExpandable = {isExpandable }
    /></div>
      </Box>
      <Box key={this.props.key} overflow="hidden" width="100%" height="max-content" sx={{display:{md:"none", xs:"flex"}}}>
      <div key={this.props.key} className='accessories' style={{background:"white"}}>
                  {accessories.map((item, key)=>{return(
                  <div key={key} className='accessory-container'>
                    <div className='accessory-image'>
                    <ProductImage product={ item } alt={ item.productCode } className="image-container" />
                    </div>
                    <div className='accessory-section'>
                      <div className='accessory-details'>
                      <ProductCode { ...item } />
                      <ProductDescription product={ item } ></ProductDescription>
                      <ProductDescription product={ item } shortdescriptioncn></ProductDescription>
                      <span className='quantity'>{`${translate("Quantity")}: ${1}`}</span>
                      {this.props.showAvailability && <ProductStock product={item}></ProductStock>}
                      </div>
                      {this.props.showPriceColumn &&<div className='accessory-price'>
                        <ProductPrice product={item}></ProductPrice>
                      </div>}
                    </div>
                  </div>)})}
                </div>
      </Box></>
  }
}

ProductItemDetailComponent.propTypes = {
  configuration: PropTypes.shape( {
    model: PropTypes.shape( {} ),
    product: PropTypes.shape( {
      name: PropTypes.string
    } ),
    productModelType: PropTypes.number
  } ),
  getProduct: PropTypes.func.isRequired,
  parentLayoutType: PropTypes.string,
  product: PropTypes.shape( {} )
};

export const ProductItemDetail = connect( combineStates(productState, viewsState, currentPageState), productsDispatcher )( ProductItemDetailComponent );
